// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CanvasMinimap_wrapper__qMQSM","canvas":"CanvasMinimap_canvas__yc_kw"};